/* eslint-disable no-empty-pattern */
/* eslint-disable camelcase */
/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
/* eslint-disable react/prop-types */
import React, { useState, useRef } from "react";
import { Cell, Column, HeaderCell, Table } from "rsuite-table";
import { useForm } from "react-hook-form";
import { useParams } from "react-router";

// Components
import ImageCell from "./ImageCell";
import NameCell from "./NameCell";
import Modal from "../Modal/Modal";
import ReductionCell from "./ReductionCell";
import ProductDetails from "../ProductDetails/ProductDetails";
import LoaderSpinner from "../Loader/LoaderSpinner";
import FormQuantity from "../Form/FormQuantity";

// Hooks
import useModal from "../../hooks/useModal";

// Icons
import ButtonIcon from "../Button/ButtonIcon";
import CheckIcon from "../../assets/icons/CheckIcon";
import DeleteIcon from "../../assets/icons/DeleteIcon";

// Utils
import { getTableHeight, notify, numberToEUR } from "../../utils/utils";
import TotalHtCell from "./TotalHtCell";
import BoxIcon from "../../assets/icons/BoxIcon";
import QuantityDetails from "./modules/QuantityDetails";
import {
    useDeleteLigneDevis,
    useUpdateLigneDevis,
} from "../../api/hooks/ligneDevis.hooks";

function TableDevisDetails({
    handleSortColumn,
    sortData,
    sortColumn,
    loading,
}) {
    const [firstLaunch, setFirstLaunch] = useState(true);
    const tableRef = useRef();
    const { devisId } = useParams();
    const [productId, setProductId] = useState(null);
    const [isShowing, toggle] = useModal();

    const { isLoading: loadingEditLine, mutate: updateLigneDevis } =
        useUpdateLigneDevis(parseInt(devisId, 10));
    const { mutate: removeLigneDevis } = useDeleteLigneDevis(
        parseInt(devisId, 10)
    );

    const { setValue, getValues, control } = useForm();

    const openDetails = (id) => {
        setProductId(id);
        toggle();
    };

    const handleEditLine = (ligneId = null, productId, data) => {
        const currentScroll = Math.abs(tableRef.current.scrollY);
        if (!data.qte) {
            return notify("Quantité incorrecte", "error");
        }
        const ligneDevis = {
            ligne_devis_id: ligneId,
            devis_id: devisId,
            produit_id: productId,
            ...data,
        };
        updateLigneDevis(ligneDevis);

        return setTimeout(() => {
            tableRef.current.scrollTop(currentScroll);
        }, 500);
    };

    const handleDeleteLine = (ligneId) => {
        const currentScroll = Math.abs(tableRef.current.scrollY);
        removeLigneDevis(ligneId, {
            onSettled: () => tableRef.current.scrollTop(currentScroll),
        });
    };

    return (
        <>
            <Table
                ref={tableRef}
                height={getTableHeight(238)}
                renderLoading={LoaderSpinner}
                className="table"
                data={sortData()}
                rowHeight={100}
                sortColumn={sortColumn}
                onSortColumn={handleSortColumn}
                defaultSortType="asc"
                loading={firstLaunch && loading}
                locale={{
                    emptyMessage: "Aucun produit",
                    loading: "Chargement",
                }}
                onDataUpdated={() => !loading && setFirstLaunch(false)}
            >
                <Column>
                    <HeaderCell />
                    <ImageCell dataKey="vignette" openDetails={openDetails} />
                </Column>

                <Column flexGrow={1} minWidth={300} sortable>
                    <HeaderCell>Produit</HeaderCell>
                    <NameCell dataKey="nom" />
                </Column>

                <Column width={130}>
                    <HeaderCell>Stock virtuel</HeaderCell>
                    <Cell dataKey="stock">{({ stock }) => <p>{stock}</p>}</Cell>
                </Column>

                <Column width={115}>
                    <HeaderCell>Stock total</HeaderCell>
                    <Cell dataKey="stock">
                        {({ stock_reel }) => <p>{stock_reel}</p>}
                    </Cell>
                </Column>

                <Column width={110}>
                    <HeaderCell>Prix U. HT</HeaderCell>
                    <Cell dataKey="prix">
                        {({ prix }) => <p>{numberToEUR(prix)}</p>}
                    </Cell>
                </Column>

                <Column align="right" width={166}>
                    <HeaderCell>Quantité</HeaderCell>
                    <Cell>
                        {({
                            ligne_id,
                            qte,
                            conditionnement,
                            stock,
                            produit_desactiver,
                        }) => (
                            <FormQuantity
                                control={control}
                                defaultValue={parseFloat(qte)}
                                editable
                                max={produit_desactiver ? stock : undefined}
                                name={`${ligne_id}.qte`}
                                step={parseInt(conditionnement, 10)}
                            />
                        )}
                    </Cell>
                </Column>

                <Column align="right" width={91}>
                    <HeaderCell>
                        <p>Reduc.</p>
                    </HeaderCell>
                    <Cell>
                        {({ remise, ligne_id }) => (
                            <ReductionCell
                                name={`${ligne_id}.remise`}
                                control={control}
                                defaultValue={parseInt(remise, 10)}
                                setValue={setValue}
                            />
                        )}
                    </Cell>
                </Column>

                <Column align="right" width={140}>
                    <HeaderCell>
                        <p>Total HT</p>
                    </HeaderCell>
                    <Cell>
                        {({ ligne_id, prix }) => (
                            <TotalHtCell
                                name={ligne_id}
                                control={control}
                                prix={parseFloat(prix)}
                                getValues={getValues}
                            />
                        )}
                    </Cell>
                </Column>

                <Column fixed="right" width={176}>
                    <HeaderCell />
                    <Cell>
                        {({ id, ligne_id, declinaison }) => (
                            <div className="flex right w-100">
                                {parseInt(declinaison, 10) === 1 && (
                                    <Declinaison id={ligne_id} />
                                )}
                                <ButtonIcon
                                    onClick={() =>
                                        handleEditLine(
                                            ligne_id,
                                            id,
                                            getValues(ligne_id)
                                        )
                                    }
                                    icon={<CheckIcon />}
                                    disabled={loadingEditLine}
                                />
                                <ButtonIcon
                                    onClick={() => handleDeleteLine(ligne_id)}
                                    icon={<DeleteIcon />}
                                    status="error"
                                />
                            </div>
                        )}
                    </Cell>
                </Column>
            </Table>

            {isShowing && productId && (
                <Modal isShowing={isShowing} hide={toggle} right>
                    <ProductDetails productId={productId} />
                </Modal>
            )}
        </>
    );
}

export default TableDevisDetails;

const Declinaison = ({ id }) => {
    const [isShowing, toggle] = useModal();

    return (
        <>
            <ButtonIcon onClick={toggle} icon={<BoxIcon />} />
            {isShowing && (
                <Modal isShowing={isShowing} hide={toggle}>
                    <QuantityDetails
                        toggle={toggle}
                        ligneId={parseInt(id, 10)}
                    />
                </Modal>
            )}
        </>
    );
};
